import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import styles from './Home.module.css';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  componentDidMount(){
    //reset all data to initial state
    this.props.setPassengers([]);
    this.props.setStartDate(null);
    this.props.setEndDate(null);
    this.props.setLongHaul(false);
    this.props.setOutboundFlightData(null);
    this.props.setReturnFlightData(null);
    this.props.setOutboundSeat(null);
    this.props.setReturnSeat(null);
  }

  render() {
    return (
      <div className={styles.homePageWrapper}>
        <div className={styles.homePageExplore}>
          <h2>Explore Airbnb</h2>
          <div>

            <Link to={'#'} className={styles.destination}>
              <img src={require('./img/homes.jpg')} alt="" />
              <h3>Homes</h3>
            </Link>
            <Link to={'#'} className={styles.destination}>
              <img src={require('./img/experiences.jpg')} alt="" />
              <h3>Experiences</h3>
            </Link>
            <Link to={`/flights/browse`} onClick={() => this.props.setLongHaul(true)} className={styles.destination}>
              <img src={require('./img/flights.jpg')} alt="" />
              <h3>Flights</h3>
            </Link>
            <Link to={'#'} className={styles.destination}>
              <img src={require('./img/restaurants.jpg')} alt="" />
              <h3>Restaurants</h3>
            </Link>
          </div>
        </div>

        <div className={styles.homePageIntroducing}>
          <h2>Introducing Airbnb Plus</h2>
          <p>A new selection of homes verified for quality &amp; comfort.</p>
          <img src={require('./img/plus.jpg')} alt="" />
        </div>

        <div className={styles.homepageModule}>
          <h2>Homes around the world</h2>
          <img src={require('./img/homes-around-the-world.jpg')} alt="" />
        </div>

        <div className={styles.homepageModule}>
          <h2>Homes for your kind of trip</h2>
          <p>Find a top-rated home with amenities you need</p>
          <img src={require('./img/homes-for-your-kind-of-trip.jpg')} alt="" />
        </div>

        <div className={styles.homepageModule}>
          <h2>Top-rated experiences</h2>
          <p>Highly reviewed by locals and travelers worldwide</p>
          <img src={require('./img/top-rated-experiences.jpg')} alt="" />
        </div>

        <div className={styles.homepageModule}>
          <h2>Experiences in the spotlight</h2>
          <img src={require('./img/experiences-in-the-spotlight.jpg')} alt="" />
        </div>

        <div className={styles.homepageModule}>
          <h2>Airbnb Plus around the world</h2>
          <p>Browse a new selection of homes verified for quality &amp; comfort</p>
          <img src={require('./img/airbnb-plus-around-the-world.jpg')} alt="" />
        </div>


      </div>
    );
  }
}

const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLongHaul: data =>
      dispatch({
        type: 'SET_LONGHAUL',
        payload: data,
      }),
    setPassengers: data =>
      dispatch({
        type: 'SET_PASSENGERS',
        payload: data,
      }),
    setStartDate: data =>
      dispatch({
        type: 'SET_STARTDATE',
        payload: data
      }),
    setEndDate: data =>
      dispatch({
        type: 'SET_ENDDATE',
        payload: data
      }),
    setOutboundFlightData: data => 
      dispatch({
        type: 'SET_OUTBOUND_FLIGHT_DATA',
        payload: data
      }),
    setReturnFlightData: data => 
     dispatch({
       type: 'SET_RETURN_FLIGHT_DATA',
       payload: data
     }),
    setOutboundSeat: data => 
     dispatch({
       type: 'SET_OUTBOUND_SEAT',
       payload: data
     }),
    setReturnSeat: data => 
     dispatch({
       type: 'SET_RETURN_SEAT',
       payload: data
     })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx